// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3HleS","range":"MonthRangeSwitch_range__3YQeY","disabled":"MonthRangeSwitch_disabled__3xSIA"};